function sendRequest(
  method,
  url,
  { params, productTypeCode, loadingBar, handledAuthError },
  hasProperties = false
) {
  return new Promise((resolve, reject) => {
    method(
      url,
      params,
      loadingBar,
      false,
      {
        headers: { 'X-ResourceType': productTypeCode }
      },
      false,
      [],
      { handledAuthError }
    )
      .then((data) => {
        if (hasProperties && Object.keys(data).length > 0) {
          return resolve(data);
        }
        return resolve(data);
      })
      .catch((error) => reject(error));
  });
}
export { sendRequest };
